import { getContainerID, selectors, getLabels } from './initialization.js';

export const getSegmentTemplate = (idSuffix, id, segment = true) => {
	if (!document.getElementById(id)) {
		return '';
	}

	let template = '';

	const fallbackImage = document.querySelector(selectors.searchContainer).getAttribute('data-fallback-image');

	template += segment ? `{{#if ${id}/hits}}` : `{{#if hits}}`;
	template += segment ? `<div data-hits="{{${id}/total_hits}}" class="hits">` : `<div data-hits="{{total_hits}}" class="hits">`;

	// Additional search results headline
	if (id === getContainerID(idSuffix).searchResultsAdditional) {
		template += `{{#if ${getContainerID(idSuffix).searchResultsMain}/hits}}`;
		template += `<h5 class="hits__title">${getLabels('additional')}</h5><hr class="separator separator-length--short">`;
		template += `{{/if}}`;
	}

	template += segment ? `{{#each ${id}/hits}}` : `{{#each hits}}`;
	template += `
		<div class="hit" data-type="{{document_type}}">
			<div class="hit__image">
				{{#if images.main}}<img src="{{images.main}}" alt="{{title}}" loading="lazy" />
				{{else}}<img src="${fallbackImage}" alt="{{title}}" loading="lazy" />{{/if}}
			</div>

			<div class="hit__content">

				<div class="hit__badges">
					{{#if (isTypeDocument document_type)}}
						<span class="badge">${getLabels('download')}</span>
					{{else if (isHelpcenterUrl url)}}
						<span class="badge">Help Center</span>
					{{else if custom_fields.post_type}}
						<span class="badge">{{custom_fields.post_type}}</span>

						{{#if custom_fields.post_parent_name}}
							{{#if custom_fields.post_parent_url}}
								<a class="badge" href="{{custom_fields.post_parent_url}}">{{custom_fields.post_parent_name}}</a>
							{{else}}
								<span class="badge">{{custom_fields.post_parent_name}}</span>
							{{/if}}
						{{/if}}
					{{/if}}
				</div>

				<h6 class="hit__title">
					{{#if title}}
						{{title}}
					{{else if (isTypeDocument document_type)}}
						{{extractFilename url}}
					{{/if}}
				</h6>

				<p class="hit__description">
					{{#if meta_description}}
						{{{getMetaDescription meta_description}}}
					{{else}}
						{{{highlight}}} ...
					{{/if}}
				</p>

			</div>
	`;

	// Add link
	template += `<a class="hit__link" href="{{url}}" data-analytics-click="{{id}}"{{#if (openInNewTab url document_type)}} target="_blank" rel="noopener noreferrer"{{/if}}></a>`;

	template += `
					</div>
				{{/each}}
			</div>
		{{/if}}
	`;

	return template;
};
